var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.264,
    height: 13.264,
    viewBox: "0 0 13.264 13.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1443",
    "data-name": "Groupe 1443",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1434",
    "data-name": "Groupe 1434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1561",
    "data-name": "Trac\\xE9 1561",
    d: "M4.862,10.215a5.882,5.882,0,0,1,5.882-5.882",
    transform: "translate(-4.862 -4.333)",
    fill: "none",
    stroke: "#a128a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1562",
    "data-name": "Trac\\xE9 1562",
    d: "M16.626,25.143a5.882,5.882,0,1,1-11.764,0",
    transform: "translate(-4.862 -19.261)",
    fill: "none",
    stroke: "#a128a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1563",
    "data-name": "Trac\\xE9 1563",
    d: "M25.672,4.333a5.882,5.882,0,0,1,5.882,5.882",
    transform: "translate(-19.79 -4.333)",
    fill: "none",
    stroke: "#a128a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1222",
    "data-name": "Groupe 1222",
    transform: "translate(4.65 3.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1221",
    "data-name": "Groupe 1221",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1168",
    "data-name": "Trac\\xE9 1168",
    d: "M23.511,17.008a.632.632,0,0,0,.458-.191.643.643,0,0,0-.458-1.1.608.608,0,0,0-.454.19.623.623,0,0,0-.191.458.608.608,0,0,0,.191.454A.619.619,0,0,0,23.511,17.008Z",
    transform: "translate(-22.427 -15.716)",
    fill: "#a128a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1169",
    "data-name": "Trac\\xE9 1169",
    d: "M23.778,24.175H23.35s-.207,0-.214-.19c-.02-.254-.037-.462-.039-.522l-.025-.62c0-.038,0-.087,0-.148q0-.2,0-.32v-.1l.011-.264V21.4a6.265,6.265,0,0,1-1.622.549l-.1.44a1.335,1.335,0,0,0,.253.024.834.834,0,0,0,.317-.06l.014.884c0,.216.006.491.012.766a.166.166,0,0,1-.157.175h-.487v.946h2.465Z",
    transform: "translate(-21.313 -19.79)",
    fill: "#a128a8"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcone);
export default __webpack_public_path__ + "static/media/infoIcone.316653384ca02030cb275b77d5ca2928.svg";
export { ForwardRef as ReactComponent };